import { controlAudioAction } from 'actions/controlAudioAction';
import getStore from './getStore';

const store = getStore();

// kill all audio if any is playing
export const killAllAudio = () => {
  // const audios = Array.from(
  //   document.querySelectorAll('audio')
  // ) as HTMLAudioElement[];

  // audios.forEach(audio => {
  //   audio.pause();
  // });
  store.dispatch(
    controlAudioAction({
      pause: true,
    })
  );
};
